import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class HabitacionesService extends BaseService<any>{

  private static HABITACION_RESOURCE: string = "/habitaciones";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveHabitacion(habitacion: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    if (habitacion.id == null) {
      this.post(BaseService.URL_BASE + HabitacionesService.HABITACION_RESOURCE, habitacion, options, onSuccess);
    } else {
      this.put(BaseService.URL_BASE + HabitacionesService.HABITACION_RESOURCE, habitacion, options, onSuccess);
    }
  }

  public deleteHabitacion(habitacion: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + HabitacionesService.HABITACION_RESOURCE + "/" + habitacion.id, options, onSuccess);
  }

  public getHabitacion(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + HabitacionesService.HABITACION_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getHabitaciones(habitacionFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    if (habitacionFilter.capacidad != null){
      params.append("capacidad", habitacionFilter.capacidad.toString() );
    }
    if (habitacionFilter.nombre != null){
      params.append("nombre", habitacionFilter.nombre.toString() );
    }
  
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + HabitacionesService.HABITACION_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/habitaciones.service.ts